module.exports = __webpack_public_path__ + "img/elec.31b86997.png";